import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { EMPTY } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { PathwayMembershipsBackend } from '@libs/src/pathway-memberships/pathway-memberships.backend';

import { PathwayMembershipPopulated } from '@libs/src/models/pathway-membership.interface';
import { decodeJwt } from '@libs/src/utilities/jwt.utilities';

@Injectable()
export class PathwayMembershipResolver
  implements Resolve<PathwayMembershipPopulated>
{
  constructor(
    private readonly pathwayMembershipBackend: PathwayMembershipsBackend,
  ) {}

  resolve(route: ActivatedRouteSnapshot) {
    const token = route.queryParamMap.get('pathwayToken');
    if (!token) {
      return null;
    }
    const { pathwayMembershipId } = (decodeJwt(token) ?? {}) as {
      pathwayMembershipId?: string;
    };
    if (!pathwayMembershipId) {
      return null;
    }
    return this.pathwayMembershipBackend.v4
      .getPathwayMembershipToken(token)
      .pipe(
        map(
          ({
            pathwayMembership,
          }: {
            pathwayMembership: PathwayMembershipPopulated;
          }) => pathwayMembership,
        ),
        catchError(() => EMPTY),
      );
  }
}
